import {Ref} from "vue";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import SearchingAndSuggestionUtil from "@/utils/editView/widgets/SearchingAndSuggestionUtil.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import {useLoadingStore} from "@/stores/LoadingStore.ts";
import FieldMetaData = namaTypes.FieldMetaData;
import GenericValue = namaTypes.GenericValue;
import SuggestionProvidedItem = namaTypes.SuggestionProvidedItem;
import {FromGridAction} from "@/utils/UIConstants/enums.ts";

export default class SuggestionProviderFieldWidgetUtil extends FieldWidgetUtil
{
  constructor(presenter: WidgetsPresenter, fieldMetaData: FieldMetaData) {
    super(presenter, fieldMetaData);
  }

  async suggest(val: string | null | undefined, options: Ref<namaTypes.SuggestionProvidedItem[]>) {
    let contextFields: Record<string, GenericValue> = {};
    this.presenter.fetchDispatcher().addContextFieldsToMap(this.fieldId(), this.createContextFieldsIds(), -1
      , contextFields, FromGridAction.No, [], {});
    let placeExtraFilter;
    if (this.presenter.isEditPresenter())
      placeExtraFilter = (this.presenter as EditPresenter).getPlaceExtraFieldFilterId();
    options.value = await SearchingAndSuggestionUtil.suggest({
      fieldId: this.fieldId(),
      entityType: this.presenter.entityType,
      contextFields,
      currentText: val,
      placeExtraFilter
    });
  }

  onSelect = async (value?: SuggestionProvidedItem) => {
    let originalValue = this.fetchFieldValue();
    this.onPartialUserInput(value ? value['optionText'] : null);
    await this.onUserInputFinished();
    if (this.inputFieldValueRef.value !== originalValue) {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      if (value && value.fieldsToUpdate)
        await this.presenter.fetchDispatcher().onGuiActionUpdateList(value.fieldsToUpdate);
      if (this.presenter.fetchDispatcher())
        await this.presenter.fetchDispatcher().validate(this.fieldId())
      loadingStore.stopLoading();
    }
  }
}
